<template>
  <v-list
    v-if="blankRepresentative"
    :class="{
      'v-list--bg-transparent': transparent,
      'v-list--horizontal': horizontal,
      'd-inline-flex flex-wrap flex-md-nowrap': horizontal
    }"
  >
    <v-list-item>
      <v-list-item-avatar>
        <v-img
          :src="require('@/assets/images/icons/user_profile_thick.svg')"
          alt="Przedstawiciel"
        />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ blankRepresentative.name }}</v-list-item-title>
        <v-list-item-subtitle>Przedstawiciel handlowy</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="btnClose">
        <v-btn icon color="red" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-list-item>
      <v-list-item-icon>
        <v-icon color="indigo darken-2"> mdi-phone </v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ blankRepresentative.mobile }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-icon>
        <v-icon color="indigo darken-2"> mdi-email </v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ blankRepresentative.email }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'BlankRepresentative',
  props: {
    btnClose: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    transparent: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    horizontal: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  computed: {
    blankRepresentative: get('blank/data@representative')
  }
}
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/settings/_variables';

.v-list.v-list--horizontal {
  &.v-list--bg-transparent.theme--light {
    background: transparent;
  }

  // @media (min-width: 960px) {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    &::v-deep .v-list-item {
      padding: 0px;
    }
    &::v-deep .v-list-item__icon {
      margin-right: 10px;
    }
  }
}
</style>
